import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AgGridModule} from 'ag-grid-angular';
import {vmiRoutingModule} from './vmi-routing.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {VmiHomeComponent} from './views/vmi-home/vmi-home.component';
import {
  VmiFrmMantenedorArticulosComponent
} from './views/administracion/vmi-frm-mantenedor-articulos/vmi-frm-mantenedor-articulos.component';
import {
  VmiFrmMantenedorAmortiguadorComponent
} from './views/administracion/vmi-frm-mantenedor-amortiguador/vmi-frm-mantenedor-amortiguador.component';
import {
  VmiFrmMantenedorTanquesComponent
} from './views/administracion/vmi-frm-mantenedor-tanques/vmi-frm-mantenedor-tanques.component';
import {
  VmiFrmMantenedorClientesComponent
} from './views/administracion/vmi-frm-mantenedor-clientes/vmi-frm-mantenedor-clientes.component';
import {
  VmiFrmMantenedorColorPorcentajeComponent
} from './views/administracion/vmi-frm-mantenedor-color-porcentaje/vmi-frm-mantenedor-color-porcentaje.component';
import {
  VmiFrmMantenedorUsuariosComponent
} from './views/administracion/vmi-frm-mantenedor-usuarios/vmi-frm-mantenedor-usuarios.component';
import {
  VmiFrmMantenedorAlertasComponent
} from './views/administracion/vmi-frm-mantenedor-alertas/vmi-frm-mantenedor-alertas.component';
import {
  VmiFrmMantenedorReporteDiarioComponent
} from './views/administracion/vmi-frm-mantenedor-reporte-diario/vmi-frm-mantenedor-reporte-diario.component';
import {
  VmiFrmMantenedorRefrescamientoTanquesComponent
} from './views/administracion/vmi-frm-mantenedor-refrescamiento-tanques/vmi-frm-mantenedor-refrescamiento-tanques.component';
import {
  VmiReportePenetracionComponent
} from './views/informes/vmi-reporte-penetracion/vmi-reporte-penetracion.component';
import {
  VmiReporteEstadoProductoComponent
} from './views/informes/vmi-reporte-estado-producto/vmi-reporte-estado-producto.component';
import {TooltipModule} from 'ng2-tooltip-directive';
import { VmiFrmMantenedorPedidosComponent } from './views/administracion/vmi-frm-mantenedor-pedidos/vmi-frm-mantenedor-pedidos.component';
import { VmiReportePenetracionClasicoComponent } from './views/informes/vmi-reporte-penetracion-clasico/vmi-reporte-penetracion-clasico.component';
import { VmiReporteSegumientoComponent } from './views/informes/vmi-reporte-seguimiento/vmi-reporte-seguimiento.component';
import { VmiFrmMantenedorIntegradorComponent } from './views/administracion/vmi-frm-mantenedor-integador/vmi-frm-mantenedor-integrador.component';


@NgModule({
  declarations: [
    VmiHomeComponent,
    VmiFrmMantenedorArticulosComponent,
    VmiFrmMantenedorAmortiguadorComponent,
    VmiFrmMantenedorTanquesComponent,
    VmiFrmMantenedorClientesComponent,
    VmiFrmMantenedorColorPorcentajeComponent,
    VmiFrmMantenedorUsuariosComponent,
    VmiFrmMantenedorAlertasComponent,
    VmiFrmMantenedorReporteDiarioComponent,
    VmiFrmMantenedorRefrescamientoTanquesComponent,
    VmiReportePenetracionComponent,
    VmiReporteEstadoProductoComponent,
    VmiFrmMantenedorPedidosComponent,
    VmiReportePenetracionClasicoComponent,
    VmiReporteSegumientoComponent,
    VmiFrmMantenedorIntegradorComponent,
    
  ],
  exports: [],
  imports: [
    CommonModule,
    vmiRoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TooltipModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
  ]
})
export class vmiModule {
}
